export const FIXED_ROLES = [
    "SuperAdmin",
    "SelfAdmin",
    "FranchiseAdmin",
    "StoreAdmin",
    "ClusterManager",
    "StoreCreator",
    "Manager",
    "Biller",
    "StoreManager",
    "Accountant"
];

export const USER_ROLES = [
    "SelfAdmin",
    "StoreCreator",
    "Accountant",
    "Manager",
];

export const EMPLOYEE_ROLES = [
    "ClusterManager",
    "StoreManager",
    "Biller",
];

export const DEFAULT_WHATSAPP_MESSAGE = `Thank you for visiting {{storeName}}. We truly appreciate your visit and look forward to serving you again.

To download your bill, please click the link below:
{{billDownloadLink}}

Regards,
{{storeName}}`;

/**
 * Formats the default WhatsApp message by replacing placeholders with actual values.
 * Placeholders:
 * - {{storeName}}
 * - {{billDownloadLink}}
 * 
 * Rules:
 * - Displays only storeName in the greeting.
 * - If billDownloadLink is unavailable, omit the download link section line.
 * - Preserves line breaks and formatting.
 */
export const formatWhatsAppMessage = ({ storeName = "", branchName = "", billDownloadLink = "" }, template = DEFAULT_WHATSAPP_MESSAGE) => {
    let message = template || DEFAULT_WHATSAPP_MESSAGE;

    const sName = (storeName || "").trim();
    const link = (billDownloadLink || "").trim();

    // 1. Replace storeName
    message = message.replace(/\{\{storeName\}\}/g, sName);

    // Remove legacy branchName placeholders if present
    message = message.replace(/\s*[–-]\s*\{\{branchName\}\}/g, "");
    message = message.replace(/\{\{branchName\}\}/g, "");

    // 2. Handle billDownloadLink
    if (link) {
        message = message.replace(/\{\{billDownloadLink\}\}/g, link);
    } else {
        // Omit the download link section line when bill download link is unavailable
        message = message.replace(/To download your bill, please click the link below:\s*\{\{billDownloadLink\}\}\n\n?/, "");
        message = message.replace(/\{\{billDownloadLink\}\}\n?/, "");
    }

    return message;
};

